import { useTableStyles } from "@saleor/remittanceRunner/styles/tableStyles";
import React from "react";

interface RemittanceRunnerTblColYesNoProps {
  label: string;
  value: boolean;
  blank?: boolean;
}

export const RemittanceRunnerTblColYesNo: React.FC<RemittanceRunnerTblColYesNoProps> = props => {
  const { label, value, blank } = props;
  const tblClasses = useTableStyles(props);

  const getDisplay = () => {
    if (blank === true) {
      return <span>-----</span>;
    } else if (value) {
      return <span>Yes</span>;
    } else {
      return <span>No</span>;
    }
  };

  return (
    <div className={tblClasses.dataGroup}>
      <div className={tblClasses.dataTitle}>{label}</div>
      <div className={tblClasses.dataDisplay}>{getDisplay()}</div>
    </div>
  );
};

export default RemittanceRunnerTblColYesNo;
